import { Hammer, MapPin, Paintbrush, Settings, ShoppingCart, Sparkles, Wrench, Zap } from 'lucide-react';

export const services = [
  {
    id: 1,
    icon: MapPin,
    title: "Виїзд на об'єкт та консультація",
    description: "Оцінюємо стан приміщення, прораховуємо вартість та обсяг робіт, виставляємо терміни здачі об'єкта",
  },
  {
    id: 2,
    icon: ShoppingCart,
    title: "Закупівля та логістика матеріалів",
    description: "Обираємо найбільш якісні матеріали відповідно до потреб замовника і самі доставляємо їх на об'єкт",
  },
  {
    id: 3,
    icon: Hammer,
    title: "Демонтажні роботи",
    description:
      "Знесення стін та перегородок, зняття старого покриття (плитка, підлога, шпалери, фарба, штукатурка), вивіз будівельного сміття",
  },
  {
    id: 4,
    icon: Wrench,
    title: "Чорнові будівельні роботи",
    description: "Вирівнюємо стіни та стелі, робимо стяжку підлоги, монтуємо гіпсокартон та ніші",
  },
  {
    id: 5,
    icon: Zap,
    title: "Проведення комунікацій",
    description:
      "Виконуємо сантехнічні роботи, займаємось електромонтажем, встановлюємо опалення, вентиляцію, кондиціонування",
  },
  {
    id: 6,
    icon: Paintbrush,
    title: "Чистові оздоблювальні роботи",
    description:
      "Наносимо штукатурку, шпаклюємо, фарбуємо або клеїмо шпалери чи декоративні покриття, укладаємо плитку, ламінат чи паркет",
  },
  {
    id: 7,
    icon: Settings,
    title: "Монтажні роботи",
    description: "Установлюємо двері, монтуємо сантехніку, освітлення, встановлюємо меблі",
  },
  {
    id: 8,
    icon: Sparkles,
    title: "Прибирання та здача об'єкта",
    description: "Запрошуємо клінінг, віддаємо вам ключ і радіємо разом з вами",
  },
]